import { CSSProperties } from 'react';
import classNames from 'classnames';
import RcCheckbox from 'rc-checkbox';
import 'rc-checkbox/assets/index.css';
import './CheckboxRadio.scss';

type CheckboxRadioProps = {
  label?: string | JSX.Element;
  prefixCls?: string;
  className?: string;
  checkboxClassName?: string;
  style?: CSSProperties;
  name?: string;
  id?: string;
  type?: string;
  defaultChecked?: number | boolean;
  checked?: number | boolean;
  disabled?: boolean;
  onFocus?: any;
  onBlur?: any;
  onClick?: any;
  tabIndex?: string | number;
  readOnly?: boolean;
  required?: boolean;
  autoFocus?: boolean;
  value?: any;
  onChange?: any;
  testId?: string;
};

const CheckboxRadio = ({
  className,
  checkboxClassName,
  style,
  name,
  id,
  type = 'checkbox',
  defaultChecked,
  checked,
  disabled,
  onFocus,
  onBlur,
  onChange,
  onClick,
  tabIndex,
  readOnly,
  required,
  autoFocus,
  value,
  label,
  prefixCls,
  testId,
}: CheckboxRadioProps): JSX.Element => {
  const labelClasses = classNames(
    'CheckboxRadio',
    {
      'CheckboxRadio--Checkbox': type === 'checkbox',
      'CheckboxRadio--Radio': type === 'radio',
      CheckboxRadio__ContainerMargin: label !== undefined,
      'CheckboxRadio--Disabled': disabled,
    },
    className,
  );

  return (
    <label className={labelClasses}>
      <RcCheckbox
        prefixCls={prefixCls}
        className={checkboxClassName}
        style={style}
        name={name}
        id={id}
        type={type}
        defaultChecked={defaultChecked}
        checked={checked}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        onClick={onClick}
        tabIndex={tabIndex}
        readOnly={readOnly}
        required={required}
        autoFocus={autoFocus}
        value={value}
        data-test-id={testId}
      />
      {label !== undefined && <span className="CheckboxRadio__InnerLabel">{label}</span>}
    </label>
  );
};

export default CheckboxRadio;
